import { EventHelper } from "app/helpers/eventHelper";
import { marketPeriodHelper } from "app/helpers/marketPeriodHelper";
import AsianOdds from "app/screens/AsianEventsScreen/components/AsianOdds/AsianOdds";
import type { EventRunnerType, EventType } from "app/types/eventType";
import get from "lodash/get";
import React from "react";
import "./AsianEventCellCorrectScore.scss";

// marketPeriod(pin):"FULL_EVENT"
// marketType(pin):"CORRECT_SCORE"
// Correct Score will have one market with a list of runners, for each score combination eg 1-0, 2-0 etc
// Need to group same score for home and away ie 1-0 and 0-1 should appear in a column under the heading 1-0
const getRunnerOddsComponent = (
  event: EventType,
  addBetSlip: Function,
  props,
  runner: EventRunnerType
): React.JSX.Element => {
  if (
    !runner ||
    !runner["aggregatedPrices"] ||
    (runner["aggregatedPrices"] && runner["aggregatedPrices"].length === 0)
  ) {
    return <div className="asian-odds-empty--small"></div>;
  }

  const highestOdds = EventHelper.getHighestOddsValueFrom(
    runner["aggregatedPrices"]
  );
  return (
    <div className={`correct-score-runner`}>
      <AsianOdds
        className={`${event["inRunning"] ? "asian-odds-live" : ""}`}
        odds={highestOdds}
        onClickPrice={() => addBetSlip(runner, props, event)}
        runner={runner}
        size={"small"}
      />
    </div>
  );
};

const AsianEventCellCorrectScore = (
  props: Record<string, any>
): null | React.ReactElement<React.ComponentProps<"div">, "div"> => {
  const { marketPeriods, event, addBetSlip } = props;
  // The market with the correct score runners should always be returned with the following structure
  const mrkt = get(marketPeriods, [0, "marketTypes", 0, "markets", 0]);
  if (!mrkt) {
    return null;
  }

  // Use a dictionary to organise the display of the runners
  const runnersDictionary = {};
  mrkt.runners.forEach(runner => {
    const oddsComponent = getRunnerOddsComponent(
      event,
      addBetSlip,
      props,
      runner
    );

    runnersDictionary[marketPeriodHelper.formatRunnerName(runner.name).trim()] =
      oddsComponent;
  });
  return (
    <div className="correct-score-container">
      <div className="correct-score-runners__group">
        {runnersDictionary["1 - 0"]}
        {runnersDictionary["0 - 1"]}
      </div>
      <div className="correct-score-runners__group">
        {runnersDictionary["2 - 0"]}
        {runnersDictionary["0 - 2"]}
      </div>
      <div className="correct-score-runners__group">
        {runnersDictionary["2 - 1"]}
        {runnersDictionary["1 - 2"]}
      </div>
      <div className="correct-score-runners__group">
        {runnersDictionary["3 - 0"]}
        {runnersDictionary["0 - 3"]}
      </div>
      <div className="correct-score-runners__group">
        {runnersDictionary["3 - 1"]}
        {runnersDictionary["1 - 3"]}
      </div>
      <div className="correct-score-runners__group">
        {runnersDictionary["3 - 2"]}
        {runnersDictionary["2 - 3"]}
      </div>
      <div className="correct-score-runners__group">
        {runnersDictionary["4 - 0"]}
        {runnersDictionary["0 - 4"]}
      </div>
      <div className="correct-score-runners__group">
        {runnersDictionary["4 - 1"]}
        {runnersDictionary["1 - 4"]}
      </div>
      <div className="correct-score-runners__group">
        {runnersDictionary["4 - 2"]}
        {runnersDictionary["2 - 4"]}
      </div>
      <div className="correct-score-runners__group">
        {runnersDictionary["4 - 3"]}
        {runnersDictionary["3 - 4"]}
      </div>
      <div className="correct-score-runners__single">
        {runnersDictionary["0 - 0"]}
      </div>
      <div className="correct-score-runners__single">
        {runnersDictionary["1 - 1"]}
      </div>
      <div className="correct-score-runners__single">
        {runnersDictionary["2 - 2"]}
      </div>
      <div className="correct-score-runners__single">
        {runnersDictionary["3 - 3"]}
      </div>
      <div className="correct-score-runners__single">
        {runnersDictionary["4 - 4"]}
      </div>
      <div className="correct-score-runners__single">
        {runnersDictionary["Any Other Score"]}
      </div>
    </div>
  );
};

export default AsianEventCellCorrectScore;
